import React, { Component } from 'react';
import Cleave from 'cleave.js/react';
import Formaters from '../../common/Formaters';
import { Run, RuleRunner } from '../Validation/RuleRunner'
import { required, minLength, regexMatch } from '../Validation/Rules';
import RegexValidator from '../Validation/RegexValidator';
import Config from "../../config"

const fieldValidations = [
  RuleRunner("finessNumber", "Le numéro Finess", required, regexMatch(RegexValidator.finessNumber, "Le numéro finess est incorrect")),
  RuleRunner("name", "La raison social", required, minLength(3)),
  RuleRunner("siret", "Le SIRET", required, regexMatch(RegexValidator.siret, "Le SIRET est incorrect")),
  RuleRunner("cipNumber", "Le CIP", required, regexMatch(RegexValidator.cipNumber, "Le CIP est incorrect")),
  RuleRunner("address", "L'adresse de la pharmacie", required, minLength(3)),
  RuleRunner("zipcode", "Le code postal", required, minLength(5), regexMatch(RegexValidator.frZipCode, "Le code postal est incorrect")),
  RuleRunner("city", "La ville", required, regexMatch(RegexValidator.beginWithText, "La ville est incorrecte")),
  RuleRunner("phoneNumber", "Le numéro de téléphone de l'officine", required, regexMatch(RegexValidator.frFixPhoneNumber, "Le numéro de téléphone est incorrect")),
  RuleRunner("fax", "Le numéro de fax de l'officine", required, regexMatch(RegexValidator.frFixPhoneNumber, "Le numéro de fax est incorrect")),
];

export default class Coordinate extends Component {

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      coordinate: props.coordinate,
      validationErrors: { },
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    var coord = this.state.coordinate;
    const name = event.target.name;
    
    // If value is equal to on thus the element is a checkbox
    // so we get the checked value
    let value = event.target.rawValue;

    if (value === null || value === undefined) {
      value = event.target.value;
    }

    if (value === "on") {
      value = event.target.checked
    }

    // Update the businessHour object
    coord[name] = value;

    this.setState({
      coordinate: coord
    });

    //this.checkForm();
  }

  checkForm() {
    var errors = Run(this.state.coordinate, fieldValidations);

    this.setState({
      validationErrors: errors
    });

    return Object.keys(errors).length === 0;
  }

  errorFor(field) {
    return this.state.validationErrors[field] || "";
  }

  getObject() {
    return this.state.coordinate;
  }

  render() {
    return (
      <fieldset className="form-fieldset" id={this.props.id}>
        <legend className="form-fieldset-legend">Votre pharmacie</legend>
        <div className="row">
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="name">Raison social</label>
              <input id="name" name="name" type="text" placeholder="Raison sociale" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.state.coordinate.name} 
                required
              />
              <span className="form-error">{this.errorFor("name")}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="cipNumber">Numéro CIP</label>
              <Cleave id="cipNumber" name="cipNumber" ref="cipNumber" type="text" placeholder="CIP" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                pattern={RegexValidator.cipNumber}
                value={this.state.coordinate.cipNumber}
                options={Formaters.cipNumber}
                required
              />
              <span className="form-error">{this.errorFor("cipNumber")}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="finessNumber">Numéro Finess</label>
              <Cleave id="finessNumber" name="finessNumber" type="text" placeholder="Numéro Finess" className={"textbox textbox-full textbox-program-"+Config.program.style}
                      onChange={this.handleChange}
                      value={this.state.coordinate.finessNumber}
                      pattern={RegexValidator.finessNumber}
                      options={Formaters.finessNumber}
                      required
              />
              <span className="form-error">{this.errorFor("finessNumber")}</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="siret">Code siret</label>
              <Cleave id="siret" name="siret" ref="siret" type="text" placeholder="SIRET" className={"textbox textbox-full textbox-program-"+Config.program.style}
                      onChange={this.handleChange}
                      pattern={RegexValidator.siret}
                      value={this.state.coordinate.siret}
                      options={Formaters.siret}
                      required
              />
              <span className="form-error">{this.errorFor("siret")}</span>
            </div>
          </div>

          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="rcs">Enregistré au RCS de </label>
              <input id="rcs" name="rcs" type="text" placeholder="Ville" className={"textbox textbox-full textbox-program-"+Config.program.style}
                     onChange={this.handleChange}
                     defaultValue={this.state.coordinate.rcs}
                     required
              />
              <span className="form-error">{this.errorFor("rcs")}</span>
            </div>
          </div>

          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="capital">Capital social</label>
              <Cleave id="capital" name="capital" type="text" placeholder="Capital social" className={"textbox textbox-full textbox-program-"+Config.program.style}
                      onChange={this.handleChange}
                      value={this.state.coordinate.capital}
                      required
              />
              <span className="form-error">{this.errorFor("capital")}</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="address">Adresse</label>
              <input id="address" name="address" type="text" placeholder="Adresse" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.state.coordinate.address}
                required
              />
              <span className="form-error">{this.errorFor("address")}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="zipcode">Code postal</label>
              <input id="zipcode" name="zipcode" type="text" placeholder="Code postal" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.state.coordinate.zipcode}
                required
              />
              <span className="form-error">{this.errorFor("zipcode")}</span>
            </div>
          </div>
          <div className="mycol-4">
            <div className="form-group">
              <label className="label" htmlFor="city">Ville</label>
              <input id="city" name="city" type="text" placeholder="Ville" className={"textbox textbox-full textbox-program-"+Config.program.style}
                onChange={this.handleChange}
                defaultValue={this.state.coordinate.city}
                required
              />
              <span className="form-error">{this.errorFor("city")}</span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="mycol-6">
            <div className="form-group">
              <label className="label" htmlFor="pharmaPhone">Téléphone</label>
              <Cleave id="pharmaPhone" name="phoneNumber" type="text" placeholder="Téléphone de l'officine" className={"textbox textbox-full textbox-program-"+Config.program.style}
                     onChange={this.handleChange}
                      value={this.state.coordinate.phoneNumber}
                     options={Formaters.phone}
                     required="required"
              />
              <span className="form-error">{this.errorFor("phoneNumber")}</span>
            </div>
          </div>
          <div className="mycol-6">
            <div className="form-group">
              <label className="label" htmlFor="pharmaFax">Fax</label>
              <Cleave id="pharmaFax" name="fax" type="text" placeholder="Fax de l'officine" className={"textbox textbox-full textbox-program-"+Config.program.style}
                      onChange={this.handleChange}
                      value={this.state.coordinate.fax}
                      options={Formaters.phone}
                      required
              />
              <span className="form-error">{this.errorFor("fax")}</span>
            </div>
          </div>
        </div>
      </fieldset>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Forms/Coordinate.js